import { gql } from "@apollo/client";

export const DELETE_APP_VERSION = gql`
  mutation DeleteAppVersion($id: Long!) {
    deleteAppVersion(id: $id)
  }
`;
